export default __webpack_public_path__ + "static/media/footer-cta-top.31af78c1.svg";